import { useFeatureFlag } from './useFeatureFlag';
import { FeatureFlagKeys } from '../constants/ff.posthog';

/**
 * Whether the office-reviews revamp (GOTU-6266) is on for this admin.
 *
 * Two surfaces read this and must agree, so they share one hook rather than
 * two `useFeatureFlag` calls: the office profile's Reviews tab (GOTU-7560) and
 * the Job Detail Rating tab (GOTU-7561). Flag on serves the rebuilt views
 * reading organization-service; flag off serves the pre-GOTU-6266 flow off the
 * monolith, which is what staging and production run until the service ships.
 *
 * **Reactive, not the synchronous `getShouldEnable*` idiom in `src/posthog.js`.**
 * PostHog fetches flags asynchronously and answers `false` until they arrive,
 * so a one-shot read would strand a flag-on admin on the legacy view whenever
 * they reach the tab before the flags land. The synchronous readers exist for
 * `App.js` route registration, which has to decide during render and cannot
 * wait. Nothing here registers a route.
 *
 * Callers must branch **above** the data hooks, choosing which component
 * mounts. `useGetOfficeReviews` and `useGetOfficeReviewByShift` are React Query
 * hooks and cannot be called conditionally, so a gate placed after them would
 * still issue the organization-service request this flag exists to prevent.
 */
export const useOfficeReviewsV2 = () =>
  useFeatureFlag(FeatureFlagKeys.officeReviewsRatingTransparency, false);

export default useOfficeReviewsV2;
